import { render, staticRenderFns } from "./TaskTemplateDialog.vue?vue&type=template&id=34a265bc"
import script from "./TaskTemplateDialog.vue?vue&type=script&lang=js"
export * from "./TaskTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplateDialog.vue?vue&type=style&index=0&id=34a265bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports